<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <!-- <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Id</th> -->
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">推广用户</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">推广等级</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">进度值</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">备注</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <!-- <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Id}}</td> -->
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.PromotionUserName}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Level}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Value}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status === -1">无效推广</span>
                    <span v-else-if="item.Status === 0">进行中</span>
                    <span v-else>完成</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Remark}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageFbFreeList as pageList, repay, queryOrder } from '../api/FBOrder.js'
import { getCurrentUser } from '../api/App'
import { debounce } from 'lodash'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        sort: '-Id'
      },
      detail: {},
      tableData: [],
      total: 0,
      addDialog: false,
      addForm: { Count: 1, UserId: 0, CodeType: 0, ValidityPeriodDay: 0 },
      user: null
    }
  },
  mounted () {
    this.getList()
    this.getUser()
  },
  methods: {
    goPay (row) {
      repay({ orderKey: row.Key, payType: row.PaymentType }).then(res => {
        if (row.PaymentType == 1) {
          window.open(res.data.data.Url, '_blank')
          return
        }
        if (row.PaymentType == 2) {
          window.open(`/wechatpay.html?key=${res.data.data.Key}&data=${res.data.data.Url}`, '_blank')
          return
        }
      }).catch(err => { console.log(err) })
    },
    getUser () {
      getCurrentUser().then(res => {
        this.user = res.data.data
      }).catch(err => { console.log(err) })
    },
    batchAdd () {
      this.addForm = { Count: 1, UserId: this.user.id, CodeType: 0, ValidityPeriodDay: 0 }
      this.addDialog = true
    },
    view (detail) {
      queryOrder(detail.OrderNo).then(res => {
        this.detail = res.data.data
        this.detailDialog = true
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page ? data.page : 1
        this.total = data.total ? data.total : 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
